module.exports = __webpack_public_path__ + "img/addTodo.fb400e2e.gif";